import { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import ru from "../assets/rs_flag.png"
import kz from "../assets/kz_flag.png"
import us from "../assets/us_flag.png"
import logo from "../assets/logo.png"

interface NavigationProps {
  t: any;
  currentPage: string;
  onPageChange: (page: string) => void;
  language: string;
  onLanguageChange: (lang: 'ru' | 'en' | 'kz') => void;
}

export default function Navigation({
  t,
  currentPage,
  onPageChange,
  language,
  onLanguageChange,
}: NavigationProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { key: 'home', label: t.home },
    { key: 'about', label: t.about },
    { key: 'product', label: t.product },
    { key: 'case-studies', label: t.caseStudies },
  ];

  return (
    <nav className="bg-[#1A1A1A] border-b border-gray-800 sticky top-0 z-50 shadow-xs shadow-green-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button
              onClick={() => onPageChange('home')}
              className="text-2xl font-bold cursor-pointer text-emerald-600 hover:text-emerald-400 transition-colors"
            >
              <img src={logo} className='w-30 mt-2' alt="" />
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {navItems.map((item) => (
                <button
                  key={item.key}
                  onClick={() => onPageChange(item.key)}
                  className={`px-3 py-2 rounded-md transition-colors ${
                    currentPage === item.key
                      ? 'bg-emerald-800 text-white'
                      : 'text-gray-300 cursor-pointer hover:bg-green-950 hover:text-white'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Language Dropdown */}
          <div className="flex relative items-center space-x-4">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                  className="border-emerald-800 cursor-pointer text-emerald-600 hover:bg-emerald-800 hover:text-white bg-transparent"
                >
                  {language.toUpperCase()}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-green-950 text-gray-200 border rounded-lg">
                <DropdownMenuItem
                  onClick={() => onLanguageChange('ru')}
                  className="hover:bg-emerald-800 hover:text-white cursor-pointer"
                >
                  <img src={ru} className='w-4' /> Русский
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => onLanguageChange('en')}
                  className="hover:bg-emerald-800 hover:text-white cursor-pointer"
                >
                  <img src={us} className='w-4' /> English
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => onLanguageChange('kz')}
                  className="hover:bg-emerald-800 hover:text-white cursor-pointer"
                >
                  <img src={kz} className='w-4' /> Қазақша
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-gray-800">
              {navItems.map((item) => (
                <button
                  key={item.key}
                  onClick={() => {
                    onPageChange(item.key);
                    setIsMenuOpen(false);
                  }}
                  className={`block px-3 py-2 rounded-md text-base font-medium transition-colors w-full text-left ${
                    currentPage === item.key
                      ? 'bg-emerald-800 text-white'
                      : 'text-gray-300 hover:bg-green-950 hover:text-white'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
